<template>
    <v-container class="my-5">
        <!--    Diálogo  Modal para Mostrar Casas X Lote   -->
        <v-dialog v-model="dialogGetDevicesByGuardhouse" scrollable max-width="450">
          <v-card class="elevation-5">
            <v-toolbar dark color="primary">
              <v-toolbar-title>
                Lotes
              </v-toolbar-title>
              <v-spacer></v-spacer>
              <v-btn
                  class="align-self-end"
                  color="red"
                  icon
                  @click="dialogGetDevicesByGuardhouse = false">
                <v-icon>mdi-close</v-icon>
              </v-btn>
            </v-toolbar>
            <v-card-text><br>
              <v-layout row wrap class="justify-center">
                <v-flex xs8>
                  <v-text-field
                      v-model="lot_number"
                      name="lot_number"
                      dense
                      outlined
                      prepend-icon="mdi-land-plots"
                      label="Lote"
                      :error-messages="errores.lot_number"
                  ></v-text-field>
                </v-flex>
                <v-flex xs4>
                  <v-btn :loading="loading" block color="primary" @click="addLote">
                    {{$t('agregar')}}
                  </v-btn>
                </v-flex>
              </v-layout>
              <v-divider></v-divider>
              <div v-if="devicesByGuardhouse.length > 0">
                <v-list four-line v-for="(item, i) in devicesByGuardhouse" :key="i">
                  <v-list-item>
                    <v-list-item-content>
                      <v-list-item-subtitle>{{$t('direccion')}}: <strong>{{item.street}} {{item.number}}</strong></v-list-item-subtitle>
                      <v-list-item-title>Lote: <strong>{{item.lot_number}}</strong></v-list-item-title>
                    </v-list-item-content>
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on, attrs }">
                        <v-icon
                            v-bind="attrs"
                            v-on="on"
                            medium
                            color="gray"
                            class="mr-2"
                            @click="update = true, idUpdateLot = item.id, errores = [], dialogDevice = true, lot_number = item.lot_number"
                        >
                          mdi-pencil
                        </v-icon>
                      </template>
                      <span>{{$t('change')}}</span>
                    </v-tooltip>
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on, attrs }">
                        <v-icon
                            v-bind="attrs"
                            v-on="on"
                            medium
                            color="red"
                            class="mr-2"
                            @click="idUpdateLot = item.id, deleteLotDialog = true"
                        >
                          mdi-close
                        </v-icon>
                      </template>
                      <span>{{$t('delete')}}</span>
                    </v-tooltip>
                  </v-list-item>
                </v-list>
              </div>
              <div v-else class="text-center">
                <h4>{{$t('no_lots')}}</h4>
              </div>
              <v-divider></v-divider>
            </v-card-text>
          </v-card>
        </v-dialog>
        <!--   Diálogo para Mostrar un mensaje cuando no se puede Eliminar Casa     -->
        <v-dialog
                v-model="dialogUnauthorized"
                max-width="450"
        >
            <v-card>
                <v-card-title class="headline">
                    {{$t('msg_can_not_delete_house01')}}
                </v-card-title>

                <v-card-text>
                    {{$t('msg_can_not_delete_house02')}}
                </v-card-text>

                <v-card-actions class="text-center">
                    <v-spacer></v-spacer>
                    <v-btn
                            color="primary"
                            @click="dialogUnauthorized = false"
                    >
                        {{$t('cerrar')}}
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <!--   Dialogo para modificar numero de lote   -->
        <v-dialog v-model="dialogDevice" persistent max-width="300">
          <v-card class="elevation-5">
            <v-toolbar dark color="primary">
              <v-toolbar-title>
                Lotes
              </v-toolbar-title>
              <v-spacer></v-spacer>
              <v-btn
                  class="align-self-end"
                  color="red"
                  icon
                  @click="lot_number = '', dialogDevice = false">
                <v-icon>mdi-close</v-icon>
              </v-btn>
            </v-toolbar>
            <v-card-text>
              <br>
              <v-layout row wrap class="justify-center">
                <v-flex xs8>
                  <v-text-field
                      v-model="lot_number"
                      name="lot_number"
                      dense
                      outlined
                      prepend-icon="mdi-land-plots"
                      label="Lote"
                      :error-messages="errores.lot_number"
                  ></v-text-field>
                </v-flex>
                <v-flex xs4>
                  <v-btn :loading="loading" block color="primary" @click="updateDevice">
                    {{$t('modificar')}}
                  </v-btn>
                </v-flex>
              </v-layout>
            </v-card-text>
          </v-card>
        </v-dialog>
        <!--   Diálogo para Mostrar un mensaje al Eliminar Casa     -->
        <v-dialog
                v-model="deleteDialog"
                max-width="450"
        >
            <v-card>
                <v-card-title class="headline">
                    {{$t('msg_eliminar_casa')}}
                </v-card-title>

                <v-card-text>
                    {{$t('msg_accion_deshacer')}}
                </v-card-text>

                <v-card-actions>
                    <v-btn
                            color="primary"
                            @click="deleteDialog = false"
                    >
                        No
                    </v-btn>
                    <v-spacer></v-spacer>
                    <v-btn
                            color="primary"
                            @click="deleteHouse()"
                    >
                        {{$t('Si')}}
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <!--   Diálogo para Mostrar un mensaje al Eliminar Lote     -->
        <v-dialog
                v-model="deleteLotDialog"
                max-width="450"
        >
            <v-card>
                <v-card-title class="headline">
                    {{$t('msg_delete_lot')}}
                </v-card-title>

                <v-card-text>
                    {{$t('msg_accion_deshacer')}}
                </v-card-text>

                <v-card-actions>
                    <v-btn
                            color="primary"
                            @click="deleteLotDialog = false"
                    >
                        No
                    </v-btn>
                    <v-spacer></v-spacer>
                    <v-btn
                            color="primary"
                            :loading="loading"
                            @click="deleteDevice()"
                    >
                        {{$t('Si')}}
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <!--   Diálogo importar Casas     -->
        <v-dialog
                v-model="dialogImport"
                max-width="700"
        >
            <v-card>
                <v-toolbar dark color="primary">
                    <v-toolbar-title>
                        {{$t('importar_casas_archivo')}}
                    </v-toolbar-title>
                    <v-spacer></v-spacer>
                    <v-btn
                            class="align-self-end"
                            color="red"
                            icon
                            @click="clear(), dialogImport = false"
                    ><v-icon>mdi-close</v-icon></v-btn>
                </v-toolbar>
<!--                <v-card-title class="headline">-->
<!--                    {{$t('importar_casas')}}-->
<!--                </v-card-title>-->
                <v-card-text>
                    <br>
                    <h3>{{$t('msg_importar_casas')}}</h3>
                    <br>
                    <v-expansion-panels>
                        <v-expansion-panel>
                            <v-expansion-panel-header>{{$t('mostrar_formato')}}</v-expansion-panel-header>
                            <v-expansion-panel-content>
                                <v-simple-table>
                                    <template v-slot:default>
                                        <thead>
                                        <tr>
                                            <th class="text-center">{{$t('nombre_calle')}}</th>
                                            <th class="text-center">{{$t('numero_casa')}}</th>
                                            <th class="text-center">{{$t('telefono')}} 1</th>
                                            <th class="text-center">{{$t('telefono')}} 2</th>
                                            <th class="text-center">{{$t('telefono')}} 3</th>
                                        </tr>
                                        </thead>
                                        <tbody>
                                        <tr v-for="item in housesToImpoort" :key="item.name">
                                            <td class="text-center">{{ item.nombre_calle }}</td>
                                            <td class="text-center">{{ item.numero_casa }}</td>
                                            <td class="text-center">{{ item.telefono1 }}</td>
                                            <td class="text-center">{{ item.telefono2 }}</td>
                                            <td class="text-center">{{ item.telefono3 }}</td>
                                        </tr>
                                        </tbody>
                                    </template>
                                </v-simple-table>
                            </v-expansion-panel-content>
                        </v-expansion-panel>
                    </v-expansion-panels>
                    <br>
                    <v-file-input
                            v-model="file"
                            :rules="rules"
                            chips
                            show-size
                            accept=".xlsx"
                            :placeholder="$t('selecciona_archivo')"
                            :label="$t('archivo')"
                            :error-messages="errores.file"
                    ></v-file-input>
                </v-card-text>
                <v-card-actions>
                    <v-btn
                            color="primary"
                            @click="dialogImport = false"
                    >
                        {{$t('cancelar')}}
                    </v-btn>
                    <v-spacer></v-spacer>
                    <v-btn
                            color="primary"
                            :loading="loading"
                            @click="importar()"
                    >
                            <v-icon dark left>mdi-database-import</v-icon>
                        {{$t('importar')}}
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <!--    Diálogo Modal Cambiar permisos para que vigilante vea los telefonos de las casas    -->
        <v-dialog v-model="dialogAllowShowHousePhones" max-width="350">
                <v-card class="elevation-5">
                    <v-toolbar dark color="primary">
                        <v-toolbar-title>
                            {{$t('show_house_phones')}}
                        </v-toolbar-title>
                        <v-spacer></v-spacer>
                        <v-btn
                                class="align-self-end"
                                color="red"
                                icon
                                @click="dialogAllowShowHousePhones = false">
                            <v-icon>mdi-close</v-icon>
                        </v-btn>
                    </v-toolbar>
                  <v-card-text class="text-center">
                        {{$t('msg_allow_show_house_phones')}}
                        <v-layout align-center justify-center fill-height>
                            <v-switch
                                    :loading="loadingallowShowHousePhones"
                                    v-model="allowShowHousePhones"
                                    @change="changeAllowShowHousePhones()"
                                    :label="allowShowHousePhones === true ? $t('Si') : 'No'">
                            </v-switch>
                        </v-layout>
                    </v-card-text>
                </v-card>
        </v-dialog>
        <h2 class="subheading grey--text">{{$t('casas')}}</h2>
        <v-layout align-center justify-center fill-height>
            <v-dialog v-model="dialog" persistent scrollable max-width="650">
                <template v-slot:activator="{ on }">
                    <v-layout row wrap class="justify-center">
                        <v-btn
                                color="primary"
                                v-on="on"
                                @click="update = false, cleanFields()"
                        >
                            + {{$t('anadir_casa')}}
                        </v-btn>
<!--                        <v-btn-->
<!--                                color="primary"-->
<!--                                @click="dialogImport = true, file = null, clear()"-->
<!--                        >-->
<!--                            <v-icon dark left>mdi-database-import</v-icon>-->
<!--                            {{$t('importar_casas')}}-->
<!--                        </v-btn>-->
                        <v-btn
                                color="primary"
                                @click="getShowHousePhones(), dialogAllowShowHousePhones = true"
                        >
                            <v-icon dark left>mdi-phone-log</v-icon>
                            {{$t('show_house_phones')}}
                        </v-btn>
                    </v-layout>
                </template>
                <v-form
                        @submit.prevent="update
                            ? updateHouse(idUpdate)
                            : addHouse()"
                >
                    <v-card class="elevation-5">
                        <v-toolbar dark color="primary">
                            <v-toolbar-title>
                                {{$t('casas')}}
                            </v-toolbar-title>
                            <v-spacer></v-spacer>
                            <v-btn
                                    class="align-self-end"
                                    color="red"
                                    icon
                                    @click="clear(), dialog = false"
                            ><v-icon>mdi-close</v-icon></v-btn>
                        </v-toolbar>
                        <v-card-text>
                            <v-layout row wrap>
                              <v-flex xs12 sm8>
                                <v-text-field
                                    v-if="dialog" autofocus
                                    v-model="street"
                                    name="street"
                                    prepend-icon="mdi-road"
                                    :label="$t('nombre_calle')"
                                    :error-messages="errores.street"
                                ></v-text-field>
                              </v-flex>
                              <v-flex xs12 sm4>
                                <v-text-field
                                    v-model="number"
                                    name="number"
                                    prepend-icon="mdi-numeric-1-box"
                                    :label="$t('numero_casa')"
                                    :error-messages="errores.number"
                                ></v-text-field>
                              </v-flex>
                            </v-layout>
                            <v-divider></v-divider>
                            <v-layout row wrap>
                              <v-flex xs12>
                                <v-textarea
                                    v-model="instructions"
                                    name="instructions"
                                    prepend-icon="mdi-bulletin-board"
                                    :label="$t('instructions')"
                                    counter
                                    maxlength="500"
                                    :error-messages="errores.instructions"
                                ></v-textarea>
                              </v-flex>
                            </v-layout>
                            <v-divider></v-divider>
                          <br>
                            <v-layout row wrap>
                              <v-flex xs12 sm8>
                                <v-text-field
                                        v-model="name1"
                                        name="name1"
                                        prepend-inner-icon="mdi-account"
                                        counter
                                        outlined
                                        maxlength="200"
                                        :label="$t('nombre') + ' 1'"
                                        :error-messages="errores.name1"
                                ></v-text-field>
                              </v-flex>
                              <v-flex xs12 sm4>
                                <v-text-field
                                        v-model="housePhoneNumber"
                                        name="housePhoneNumber"
                                        prepend-icon="mdi-phone"
                                        counter
                                        outlined
                                        maxlength="13"
                                        :label="$t('telefono') + ' 1'"
                                        :error-messages="errores.phone"
                                ></v-text-field>
                              </v-flex>
                            </v-layout>
                            <v-layout row wrap>
                              <v-flex xs12 sm8>
                                <v-text-field
                                        v-model="name2"
                                        name="name2"
                                        prepend-inner-icon="mdi-account"
                                        counter
                                        outlined
                                        maxlength="200"
                                        :label="$t('nombre') + ' 2'"
                                        :error-messages="errores.name2"
                                ></v-text-field>
                              </v-flex>
                              <v-flex xs12 sm4>
                                <v-text-field
                                        v-model="housePhoneNumber2"
                                        name="housePhoneNumber2"
                                        prepend-icon="mdi-phone"
                                        counter
                                        outlined
                                        maxlength="13"
                                        :label="$t('telefono') + ' 2'"
                                        :error-messages="errores.phone2"
                                ></v-text-field>
                              </v-flex>
                            </v-layout>
                            <v-layout row wrap>
                              <v-flex xs12 sm8>
                                <v-text-field
                                        v-model="name3"
                                        name="name3"
                                        prepend-inner-icon="mdi-account"
                                        counter
                                        outlined
                                        maxlength="200"
                                        :label="$t('nombre') + ' 3'"
                                        :error-messages="errores.name3"
                                ></v-text-field>
                              </v-flex>
                              <v-flex xs12 sm4>
                                <v-text-field
                                        v-model="housePhoneNumber3"
                                        name="housePhoneNumber3"
                                        prepend-icon="mdi-phone"
                                        counter
                                        outlined
                                        maxlength="13"
                                        :label="$t('telefono') + ' 3'"
                                        :error-messages="errores.phone3"
                                ></v-text-field>
                              </v-flex>
                            </v-layout>
                            <v-layout row wrap>
                              <v-flex xs12 sm8>
                                <v-text-field
                                        v-model="name4"
                                        name="name4"
                                        prepend-inner-icon="mdi-account"
                                        counter
                                        outlined
                                        maxlength="200"
                                        :label="$t('nombre') + ' 4'"
                                        :error-messages="errores.name4"
                                ></v-text-field>
                              </v-flex>
                              <v-flex xs12 sm4>
                                <v-text-field
                                        v-model="housePhoneNumber4"
                                        name="housePhoneNumber4"
                                        prepend-icon="mdi-phone"
                                        counter
                                        outlined
                                        maxlength="13"
                                        :label="$t('telefono') + ' 4'"
                                        :error-messages="errores.phone4"
                                ></v-text-field>
                              </v-flex>
                            </v-layout>
                            <v-layout row wrap>
                              <v-flex xs12 sm8>
                                <v-text-field
                                        v-model="name5"
                                        name="name5"
                                        prepend-inner-icon="mdi-account"
                                        counter
                                        outlined
                                        maxlength="200"
                                        :label="$t('nombre') + ' 5'"
                                        :error-messages="errores.name5"
                                ></v-text-field>
                              </v-flex>
                              <v-flex xs12 sm4>
                                <v-text-field
                                        v-model="housePhoneNumber5"
                                        name="housePhoneNumber5"
                                        prepend-icon="mdi-phone"
                                        counter
                                        outlined
                                        maxlength="13"
                                        :label="$t('telefono') + ' 5'"
                                        :error-messages="errores.phone5"
                                ></v-text-field>
                              </v-flex>
                            </v-layout>
                            <v-layout row wrap>
                              <v-flex xs12 sm8>
                                <v-text-field
                                        v-model="name6"
                                        name="name6"
                                        prepend-inner-icon="mdi-account"
                                        counter
                                        outlined
                                        maxlength="200"
                                        :label="$t('nombre') + ' 6'"
                                        :error-messages="errores.name6"
                                ></v-text-field>
                              </v-flex>
                              <v-flex xs12 sm4>
                                <v-text-field
                                        v-model="housePhoneNumber6"
                                        name="housePhoneNumber6"
                                        prepend-icon="mdi-phone"
                                        counter
                                        outlined
                                        maxlength="13"
                                        :label="$t('telefono') + ' 6'"
                                        :error-messages="errores.phone6"
                                ></v-text-field>
                              </v-flex>
                            </v-layout>
                        </v-card-text>
                        <v-card-actions>
                            <v-btn color="primary" @click="clear(), dialog = false">{{$t('cerrar')}}</v-btn>
                            <v-spacer/>
                            <v-btn v-if="update" :loading="loading" color="primary" type="submit">{{$t('modificar')}}</v-btn>
                            <v-btn v-else :loading="loading" color="primary" type="submit">{{$t('agregar')}}</v-btn>
                        </v-card-actions>
                    </v-card>
                </v-form>
            </v-dialog>
        </v-layout>
        <v-layout class="my-4" align-center justify-center fill-height>
            <v-flex >
                <v-card-title>
                    {{$t('casas')}}
                    <v-spacer></v-spacer>
                    <v-text-field
                            v-model="search"
                            append-icon="mdi-magnify"
                            :label="$t('search_by_house_number')"
                            single-line
                            hide-details
                    ></v-text-field>
                </v-card-title>
                <v-data-table
                        :headers="headers"
                        :loading="loadingDataHouses"
                        :items="houses"
                        multi-sort
                        :search="search"
                        :footer-props="{
                            itemsPerPageOptions: [
                                {text: '5', value: 5},
                                {text: '10', value: 10},
                                {text: '25', value: 25},
                                {text: this.$t('todos'), value: -1}
                            ],
                            itemsPerPageText: $t('filas_por_pagina')
                        }"
                        :no-data-text="$t('no_records_yet')"
                        class="elevation-1"
                >
                    <template v-slot:item.inhabited="{ item }">
                        <v-icon
                                v-if="item.inhabited === true"
                                medium
                                color="primary"
                                class="mr-2"
                        >
                            mdi-check
                        </v-icon>
                        <v-icon
                                v-if="item.inhabited === false"
                                medium
                                color="red"
                                class="mr-2"
                        >
                            mdi-close
                        </v-icon>
                        {{ item.inhabited ? $t('habitada') : $t('deshabitada') }}
                    </template>
                    <template v-slot:item.action="{ item }">
                        <v-tooltip bottom>
                            <template v-slot:activator="{ on, attrs }">
                                <v-icon
                                        v-bind="attrs"
                                        v-on="on"
                                        medium
                                        color="gray"
                                        class="mr-2"
                                        @click="fillFields(item), update = true, dialog = true, idUpdate = item.id"
                                >
                                    mdi-home-edit
                                </v-icon>
                            </template>
                            <span>{{$t('change')}}</span>
                        </v-tooltip>
                        <v-tooltip bottom>
                            <template v-slot:activator="{ on, attrs }">
                                <v-icon
                                        v-bind="attrs"
                                        v-on="on"
                                        medium
                                        color="red"
                                        class="mr-2"
                                        @click="deleteDialog = true, idHouseDelete = item.id"
                                >
                                    mdi-delete
                                </v-icon>
                            </template>
                            <span>{{$t('delete')}}</span>
                        </v-tooltip>
                        <v-tooltip bottom>
                            <template v-slot:activator="{ on, attrs }">
                                <v-icon
                                        v-bind="attrs"
                                        v-on="on"
                                        medium
                                        color="orange"
                                        class="mr-2"
                                        @click="dialogGetDevicesByGuardhouse = true, errores = [], idHouseDelete = item.id, getDeviceByGuardhouse()"
                                >
                                    mdi-land-plots
                                </v-icon>
                            </template>
                            <span>{{$t('show_lots')}}</span>
                        </v-tooltip>
                    </template>
                    <template v-slot:item.phone="{ item }">
                        <div>
                            {{item.phone}}
                        </div>
                        <div>
                            {{item.phone2}}
                        </div>
                        <div>
                            {{item.phone3}}
                        </div>
                        <div>
                            {{item.phone4}}
                        </div>
                        <div>
                            {{item.phone5}}
                        </div>
                        <div>
                            {{item.phone6}}
                        </div>
                    </template>
                </v-data-table>
            </v-flex>
        </v-layout>
    </v-container>
</template>

<script>
import axios from 'axios'
import store from '@/store'
import { mapState } from 'vuex'

export default {
  name: 'houses',
  created () {
    this.getHouses()
  },
  computed: {
    ...mapState(['language'])
  },
  data: () => ({
    dialog: false,
    idHouse: '',
    street: '',
    number: '',
    housePhoneNumber: '',
    name1Aux: '',
    name2Aux: '',
    name3Aux: '',
    name4Aux: '',
    name5Aux: '',
    name6Aux: '',
    instructionsAux: '',
    name1: '',
    name2: '',
    name3: '',
    name4: '',
    name5: '',
    name6: '',
    instructions: '',
    lot_number: '',
    housePhoneNumber2: '',
    housePhoneNumber3: '',
    housePhoneNumber4: '',
    housePhoneNumber5: '',
    housePhoneNumber6: '',
    streetAux: '',
    numberAux: '',
    lot_numberAux: '',
    housePhoneNumberAux: '',
    housePhoneNumber2Aux: '',
    housePhoneNumber3Aux: '',
    housePhoneNumber4Aux: '',
    housePhoneNumber5Aux: '',
    housePhoneNumber6Aux: '',
    header: [],
    loadingDataHouses: false,
    loading: false,
    houses: [],
    search: '',
    update: false,
    errores: [],
    errorsPhone: [],
    idUpdate: 0,
    idUpdateLot: 0,
    idHouseDelete: 0,
    deleteDialog: false,
    deleteLotDialog: false,
    dialogImport: false,
    dialogDevice: false,
    dialogGetDevicesByGuardhouse: false,
    devicesByGuardhouse: [],
    file: null,
    rules: [
      value => !value || value.type === 'application/wps-office.xlsx' || 'Archivo con formato incorrecto.'
    ],
    housesToImpoort: [
      {
        nombre_calle: 'Colosio',
        numero_casa: '1',
        telefono1: '+52444123456',
        telefono2: '+52444123456',
        telefono3: '+52444123456'
      },
      {
        nombre_calle: 'Colosio',
        numero_casa: '2',
        telefono1: '+52444123456',
        telefono2: '+52444123456',
        telefono3: ''
      },
      {
        nombre_calle: 'Iturbide',
        numero_casa: '123',
        telefono1: '+52444123456',
        telefono2: '',
        telefono3: ''
      },
      {
        nombre_calle: 'Carranza',
        numero_casa: '42',
        telefono1: '+52444123456',
        telefono2: '+52444123456',
        telefono3: ''
      },
      {
        nombre_calle: '...',
        numero_casa: '...',
        telefono1: '...',
        telefono2: '...',
        telefono3: '...'
      }
    ],
    headers: [],
    dialogUnauthorized: false,
    allowShowHousePhones: null,
    loadingallowShowHousePhones: false,
    dialogAllowShowHousePhones: false
  }),
  beforeUpdate () {
    this.headers = [
      {
        text: this.$t('acciones'),
        align: 'center',
        sortable: false,
        value: 'action'
      },
      {
        text: this.$t('nombre_calle'),
        align: 'center',
        sortable: true,
        value: 'street',
        filterable: false
      },
      {
        text: this.$t('numero_casa'),
        align: 'center',
        sortable: true,
        value: 'number',
        filterable: true
      },
      {
        text: 'Lote',
        align: 'left',
        sortable: true,
        value: 'lot_number',
        filterable: true
      },
      {
        text: this.$t('telefono'),
        align: 'center',
        sortable: true,
        value: 'phone',
        filterable: false
      },
      {
        text: this.$t('habitada'),
        align: 'center',
        sortable: true,
        value: 'inhabited',
        filterable: false
      }
    ]
  },
  methods: {
    addLote () {
      if (this.lot_number === '') {
        this.lot_numberAux = ' '
      } else {
        this.lot_numberAux = this.lot_number
      }
      this.loading = true
      this.errores = []
      var bodyFormData = new FormData()

      bodyFormData.set('idHouse', this.idHouseDelete)
      bodyFormData.set('lot_number', this.lot_numberAux)
      const config = {
        method: 'post',
        url: 'https://residencial-services.intrare.app/house_per_lot/',
        headers: {
          'Content-Type': 'application/json',
          'Accept-Language': this.language,
          'authorization': 'Token ' + store.getters.getToken
        },
        data: bodyFormData
      }
      axios(config)
        .then(ok => {
          this.loading = false
          this.$store.commit('snackbar_activate_true')
          this.$store.commit('snackbar_change_message', this.$t('msg_lot_add'))
          this.lot_number = ''
          this.getHouses()
          this.getDeviceByGuardhouse()
          setTimeout(this.clear, 3000)
        })
        .catch(error => {
          this.loading = false
          if (error.response.status === 400 && typeof error.response.data === 'object' && error.response.data) {
            if (error.response.data) {
              this.errores = error.response.data
              console.log(this.errores.phone2)
            }
            if (error.response.data.non_field_errors) {
              this.errorsPhone = error.response.data.non_field_errors
            }
          }
        })
    },
    updateDevice () {
      if (this.lot_number === '') {
        this.lot_numberAux = ' '
      } else {
        this.lot_numberAux = this.lot_number
      }
      this.errores = []
      this.loading = true
      const config = {
        method: 'PATCH',
        url: 'https://residencial-services.intrare.app/house_per_lot/' + this.idUpdateLot + '/',
        headers: {
          'Content-Type': 'application/json',
          'Accept-Language': this.language,
          'authorization': 'Token ' + store.getters.getToken
        },
        data: {
          idHouse: this.idHouseDelete,
          lot_number: this.lot_numberAux
        }
      }
      axios(config)
        .then(ok => {
          this.loading = false
          this.$store.commit('snackbar_activate_true')
          this.$store.commit('snackbar_change_message', this.$t('device_modified_successfully'))
          this.lot_number = ''
          this.dialogDevice = false
          this.getHouses()
          this.getDeviceByGuardhouse()
          setTimeout(this.clear, 3000)
        })
        .catch(error => {
          this.loading = false
          if (error.response.status === 400 && typeof error.response.data === 'object' && error.response.data) {
            this.errores = error.response.data
          }
        })
    },
    deleteDevice () {
      this.errores = []
      this.loading = true
      const config = {
        method: 'DELETE',
        url: 'https://residencial-services.intrare.app/house_per_lot/' + this.idUpdateLot + '/',
        headers: {
          'Content-Type': 'application/json',
          'Accept-Language': this.language,
          'authorization': 'Token ' + store.getters.getToken
        }
      }
      axios(config)
        .then(ok => {
          this.loading = false
          this.$store.commit('snackbar_activate_true')
          this.$store.commit('snackbar_change_color', 'warning')
          this.$store.commit('snackbar_change_message', this.$t('lot_removed_successfully'))
          this.getHouses()
          this.getDeviceByGuardhouse()
          setTimeout(this.clear, 3000)
          this.deleteLotDialog = false
        })
        .catch(error => {
          this.loading = false
          this.deleteLotDialog = false
          if (error.response.status === 400 && typeof error.response.data === 'object' && error.response.data) {
            this.errores = error.response.data
          }
        })
    },
    getDeviceByGuardhouse () {
      this.devicesByGuardhouse = []
      const config = {
        method: 'get',
        url: 'https://residencial-services.intrare.app/house_per_lot/' + this.idHouseDelete + '/house/',
        headers: {
          'Content-Type': 'application/json',
          'Accept-Language': this.language,
          'authorization': 'Token ' + store.getters.getToken
        }
      }
      axios(config)
        .then(response => {
          this.devicesByGuardhouse = response.data
        })
        .catch(error => {
          console.log(error)
        })
    },
    getShowHousePhones () {
      this.loadingallowShowHousePhones = true
      const config = {
        method: 'get',
        url: 'https://residencial-services.intrare.app/housing_unit/info/show_house_phones/',
        headers: {
          'Content-Type': 'application/json',
          'Accept-Language': this.language,
          'authorization': 'Token ' + store.getters.getToken
        }
      }
      axios(config)
        .then(response => {
          this.loadingallowShowHousePhones = false
          this.allowShowHousePhones = response.data.show_house_phones
        })
        .catch(error => {
          this.loadingallowShowHousePhones = false
          console.log(error)
        })
    },
    changeAllowShowHousePhones () {
      this.loadingallowShowHousePhones = true
      const config = {
        method: 'patch',
        url: 'https://residencial-services.intrare.app/housing_unit/update/wallpaper/',
        headers: {
          'Content-Type': 'application/json',
          'Accept-Language': this.language,
          'authorization': 'Token ' + store.getters.getToken
        },
        data: {
          show_house_phones: this.allowShowHousePhones
        }
      }
      axios(config)
        .then(ok => {
          this.loadingallowShowHousePhones = false
          // console.log(ok)
          this.$store.commit('snackbar_activate_true')
          this.$store.commit('snackbar_change_message', this.$t('cambios_aplicados'))
          setTimeout(this.clear, 3000)
        })
        .catch(error => {
          if (error.response.status === 400 && typeof error.response.data === 'object' && error.response.data) {
            this.errores = error.response.data
          }
          this.loadingallowShowHousePhones = false
        })
    },
    getHouses () {
      this.loadingDataHouses = true
      const config = {
        method: 'get',
        url: 'https://residencial-services.intrare.app/house/',
        headers: {
          'Content-Type': 'application/json',
          'Accept-Language': this.language,
          'authorization': 'Token ' + store.getters.getToken
        }
      }
      axios(config)
        .then(response => {
          this.houses = response.data
          this.loadingDataHouses = false
        })
        .catch(error => {
          this.loadingDataHouses = false
          console.log(error)
        })
    },
    addHouse () {
      this.loading = true
      this.errores = []
      this.errorsPhone = []
      if (this.housePhoneNumber === undefined) {
        this.housePhoneNumber = null
      }
      if (this.housePhoneNumber2 === undefined) {
        this.housePhoneNumber2 = null
      }
      if (this.housePhoneNumber3 === undefined) {
        this.housePhoneNumber3 = null
      }
      if (this.housePhoneNumber4 === undefined) {
        this.housePhoneNumber4 = null
      }
      if (this.housePhoneNumber5 === undefined) {
        this.housePhoneNumber5 = null
      }
      if (this.housePhoneNumber6 === undefined) {
        this.housePhoneNumber6 = null
      }
      if (this.name1 === undefined) {
        this.name1 = null
      }
      if (this.name2 === undefined) {
        this.name2 = null
      }
      if (this.name3 === undefined) {
        this.name3 = null
      }
      if (this.name4 === undefined) {
        this.name4 = null
      }
      if (this.name5 === undefined) {
        this.name5 = null
      }
      if (this.name6 === undefined) {
        this.name6 = null
      }
      if (this.instructions === undefined) {
        this.instructions = null
      }
      console.log(this.housePhoneNumber)
      const config = {
        method: 'post',
        url: 'https://residencial-services.intrare.app/house/',
        headers: {
          'Content-Type': 'application/json',
          'Accept-Language': this.language,
          'authorization': 'Token ' + store.getters.getToken
        },
        data: {
          street: this.street,
          number: this.number,
          phone: this.housePhoneNumber,
          phone2: this.housePhoneNumber2,
          phone3: this.housePhoneNumber3,
          phone4: this.housePhoneNumber4,
          phone5: this.housePhoneNumber5,
          phone6: this.housePhoneNumber6,
          name1: this.name1,
          name2: this.name2,
          name3: this.name3,
          name4: this.name4,
          name5: this.name5,
          name6: this.name6,
          instructions: this.instructions
        }
      }
      axios(config)
        .then(ok => {
          this.loading = false
          this.$store.commit('snackbar_activate_true')
          this.$store.commit('snackbar_change_message', this.$t('mensaje_casa_alta'))
          this.dialog = false
          this.getHouses()
          setTimeout(this.clear, 3000)
        })
        .catch(error => {
          this.loading = false
          if (error.response.status === 400 && typeof error.response.data === 'object' && error.response.data) {
            if (error.response.data) {
              this.errores = error.response.data
              console.log(this.errores.phone2)
            }
            if (error.response.data.non_field_errors) {
              this.errorsPhone = error.response.data.non_field_errors
            }
          }
        })
    },
    updateHouse (id) {
      this.loading = true
      this.errores = []
      this.errorsPhone = []
      if (this.housePhoneNumber === undefined) {
        this.housePhoneNumber = null
      }
      if (this.housePhoneNumber2 === undefined) {
        this.housePhoneNumber2 = null
      }
      if (this.housePhoneNumber3 === undefined) {
        this.housePhoneNumber3 = null
      }
      if (this.housePhoneNumber4 === undefined) {
        this.housePhoneNumber4 = null
      }
      if (this.housePhoneNumber5 === undefined) {
        this.housePhoneNumber5 = null
      }
      if (this.housePhoneNumber6 === undefined) {
        this.housePhoneNumber6 = null
      }
      if (this.name1 === undefined) {
        this.name1 = null
      }
      if (this.name2 === undefined) {
        this.name2 = null
      }
      if (this.name3 === undefined) {
        this.name3 = null
      }
      if (this.name4 === undefined) {
        this.name4 = null
      }
      if (this.name5 === undefined) {
        this.name5 = null
      }
      if (this.name6 === undefined) {
        this.name6 = null
      }
      if (this.instructions === undefined) {
        this.instructions = null
      }
      var bodyFormData = new FormData()
      if (this.street !== this.streetAux) {
        bodyFormData.set('street', this.street)
      }
      if (this.number !== this.numberAux) {
        bodyFormData.set('number', this.number)
      }
      if (this.housePhoneNumber !== this.housePhoneNumberAux) {
        bodyFormData.set('phone', this.housePhoneNumber)
      }
      if (this.housePhoneNumber2 !== this.housePhoneNumber2Aux) {
        bodyFormData.set('phone2', this.housePhoneNumber2)
      }
      if (this.housePhoneNumber3 !== this.housePhoneNumber3Aux) {
        bodyFormData.set('phone3', this.housePhoneNumber3)
      }
      if (this.housePhoneNumber4 !== this.housePhoneNumber4Aux) {
        bodyFormData.set('phone4', this.housePhoneNumber4)
      }
      if (this.housePhoneNumber5 !== this.housePhoneNumber5Aux) {
        bodyFormData.set('phone5', this.housePhoneNumber5)
      }
      if (this.housePhoneNumber6 !== this.housePhoneNumber6Aux) {
        bodyFormData.set('phone6', this.housePhoneNumber6)
      }
      if (this.name1 !== this.name1Aux) {
        bodyFormData.set('name1', this.name1)
      }
      if (this.name2 !== this.name2Aux) {
        bodyFormData.set('name2', this.name2)
      }
      if (this.name3 !== this.name3Aux) {
        bodyFormData.set('name3', this.name3)
      }
      if (this.name4 !== this.name4Aux) {
        bodyFormData.set('name4', this.name4)
      }
      if (this.name5 !== this.name5Aux) {
        bodyFormData.set('name5', this.name5)
      }
      if (this.name6 !== this.name6Aux) {
        bodyFormData.set('name6', this.name6)
      }
      if (this.instructions !== this.instructionsAux) {
        bodyFormData.set('instructions', this.instructions)
      }
      console.log(this.housePhoneNumber)
      console.log(this.housePhoneNumber2)
      console.log(this.housePhoneNumber3)
      console.log(this.housePhoneNumber4)
      console.log(this.housePhoneNumber5)
      console.log(this.housePhoneNumber6)
      console.log(this.name1)
      console.log(this.name2)
      console.log(this.name3)
      console.log(this.name4)
      console.log(this.name5)
      console.log(this.name6)
      console.log(this.instructions)
      console.log('Valor de instrucciones antes de enviar:', this.instructions)
      const config = {
        method: 'patch',
        url: 'https://residencial-services.intrare.app/house/' + id + '/',
        headers: {
          'Content-Type': 'application/json',
          'Accept-Language': this.language,
          'authorization': 'Token ' + store.getters.getToken
        },
        data: bodyFormData
      }
      axios(config)
        .then(ok => {
          this.loading = false
          this.getHouses()
          this.$store.commit('snackbar_activate_true')
          this.$store.commit('snackbar_change_message', this.$t('mensaje_casa_modificado'))
          this.dialog = false
          setTimeout(this.clear, 3000)
        })
        .catch(error => {
          this.loading = false
          if (error.response.status === 400 && typeof error.response.data === 'object' && error.response.data) {
            if (error.response.data) {
              this.errores = error.response.data
            }
            if (error.response.data.non_field_errors) {
              this.errorsPhone = error.response.data.non_field_errors
            }
          }
        })
    },
    deleteHouse () {
      const config = {
        method: 'delete',
        url: 'https://residencial-services.intrare.app/house/' + this.idHouseDelete,
        headers: {
          'Content-Type': 'application/json',
          'Accept-Language': this.language,
          'authorization': 'Token ' + store.getters.getToken
        }
      }
      axios(config).then(ok => {
        console.log('House con ID_House = ', this.idHouseDelete + ' eliminado Correctamente.')
        this.$store.commit('snackbar_activate_true')
        this.$store.commit('snackbar_change_color', 'warning')
        this.$store.commit('snackbar_change_message', this.$t('mensaje_casa_eliminada'))
        this.getHouses()
        setTimeout(this.clear, 3000)
        this.deleteDialog = false
      })
        .catch(error => {
          if (error.response.status === 400 && typeof error.response.data === 'object' && error.response.data) {
            this.errores = error.response.data
          }
          if (error.response.status === 401) {
            console.log('The current house can\'t deleted')
            this.deleteDialog = false
            this.dialogUnauthorized = true
          }
        })
    },
    cleanFields () {
      this.street = ''
      this.number = ''
      this.lot_number = ''
      this.housePhoneNumber = null
      this.housePhoneNumber2 = null
      this.housePhoneNumber3 = null
      this.housePhoneNumber4 = null
      this.housePhoneNumber5 = null
      this.housePhoneNumber6 = null
      this.name1 = null
      this.name2 = null
      this.name3 = null
      this.name4 = null
      this.name5 = null
      this.name6 = null
      this.instructions = null
    },
    fillFields (item) {
      this.street = item.street
      this.number = item.number
      this.housePhoneNumber = item.phone
      this.housePhoneNumber2 = item.phone2
      this.housePhoneNumber3 = item.phone3
      this.housePhoneNumber4 = item.phone4
      this.housePhoneNumber5 = item.phone5
      this.housePhoneNumber6 = item.phone6
      this.name1 = item.name1
      this.name2 = item.name2
      this.name3 = item.name3
      this.name4 = item.name4
      this.name5 = item.name5
      this.name6 = item.name6
      this.instructions = item.instructions
      this.streetAux = item.street
      this.numberAux = item.number
      this.housePhoneNumberAux = item.phone
      this.housePhoneNumber2Aux = item.phone2
      this.housePhoneNumber3Aux = item.phone3
      this.housePhoneNumber4Aux = item.phone4
      this.housePhoneNumber5Aux = item.phone5
      this.housePhoneNumber6Aux = item.phone6
      this.name1Aux = item.name1
      this.name2Aux = item.name2
      this.name3Aux = item.name3
      this.name4Aux = item.name4
      this.name5Aux = item.name5
      this.name6Aux = item.name6
      this.instructionsAux = item.instructions
    },
    clear: function () {
      this.errores = []
      this.errorsPhone = []
      this.$store.commit('snackbar_change_color', 'success')
      // this.$validator.reset()
      this.$store.commit('snackbar_activate_false')
    },
    onInput ({ number, isValid, country }) {
      console.log(number.e164)
      console.log(isValid)
      // console.log(country)
      // console.log('CONTENIDO = ', number.e164)
      this.housePhoneNumber = number.e164
      // this.band_cellphone = isValid
    },
    onInput2 ({ number, isValid, country }) {
      console.log(number.e164)
      console.log(isValid)
      // console.log(country)
      // console.log('CONTENIDO = ', number.e164)
      this.housePhoneNumber2 = number.e164
      // this.band_cellphone = isValid
    },
    onInput3 ({ number, isValid, country }) {
      console.log(number.e164)
      console.log(isValid)
      // console.log(country)
      // console.log('CONTENIDO = ', number.e164)
      this.housePhoneNumber3 = number.e164
      // this.band_cellphone = isValid
    },
    importar () {
      console.log(this.file)
      console.log('Rules = ', this.rules)
      this.errores = []
      this.loading = true
      var bodyFormData = new FormData()
      bodyFormData.append('file', this.file)
      const config = {
        method: 'post',
        url: 'https://residencial-services.intrare.app/excel/upload/',
        headers: {
          'Content-Type': 'multipart/form-data',
          'Accept-Language': this.language,
          'authorization': 'Token ' + store.getters.getToken
        },
        data: bodyFormData
      }
      axios(config)
        .then(ok => {
          this.loading = false
          this.$store.commit('snackbar_activate_true')
          this.$store.commit('snackbar_change_message', this.$t('mensaje_casas_importadas'))
          this.dialogImport = false
          this.getHouses()
          setTimeout(this.clear, 3000)
        })
        .catch(error => {
          this.loading = false
          if (error.response.status === 400 && typeof error.response.data === 'object' && error.response.data) {
            console.log(error.response.data)
            if (error.response.data) {
              this.errores = error.response.data
            }
          }
        })
    }
  }
}
</script>

<style scoped>

</style>
